export default {
  // showSizeChanger: true,
  position: "both",
  pageSize: 100,
  // pageSizeOptions: ["10", "20", "50", "100"],
};
